import './App.css';
import { useState, useEffect, useRef } from "react";
import { request } from "./config/axios";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import MapSection from './components/Map'

function App() {
  const [msg, setMsg] = useState({
    value: [],
    notify: "",
    inputValue: "",
    lastRecieved: ""
  });

  const botMsg = useRef(null);

  useEffect(() => {
    const botMsgNode = botMsg?.current;
    if (botMsgNode) {
      // console.log(botMsgNode.innerText)
      setMsg(prev => ({
        ...prev,
        lastRecieved: botMsgNode.innerText
      }));
    }
  }, [msg.lastRecieved])

  const [autoSent, setAutoSend] = useState(null);

  const arrMsg = msg.value.map((items, i) => {
    return items.type === "sent" ? <div key={i} className="your-msg msg" dangerouslySetInnerHTML={{ __html: items.msg }}>
      {/* {items.msg} */}
    </div> :
      <div className="bot-msg msg" key={i} dangerouslySetInnerHTML={{ __html: items.msg }} ref={botMsg}>
        {/* {items.msg} */}
      </div>
  }
  );

  const commands = [
    {
      command: 'reset',
      callback: () => resetTranscript()
    },
  ]

  const {
    transcript,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    listening,
  } = useSpeechRecognition({ commands });

  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(null);

  const microphoneRef = useRef(null);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    alert("Browser has no Support for Speech Recognition. use Google Chrome!");
    handleReset();
  }

  const stopHandle = () => {
    setIsListening(false);
    microphoneRef.current.classList.remove("listening");
    SpeechRecognition.stopListening();
  };

  const handleReset = () => {
    stopHandle();
    resetTranscript();
  };

  const handleListing = async () => {
    setIsListening(true);
    microphoneRef.current.classList.add("listening");
    setMsg(prev => ({
      ...prev,
      notify: "Listening ...",
    }));
    // alert()

    return SpeechRecognition.startListening({
      continuous: true,
    });

  }

  const messageArea = useRef(null);

  const [talking, setTalking] = useState(false);

  const [speech, setSpeech] = useState(false);

  const [interview, setInterview] = useState({
    started: false,
    ready: null,
    questions: [
      "what's your name?", "What's your highest level of qualification?",
      "Send a link to your projects, either GitHub Personal Website Online Resume?", "how old are you?",
      "what's your salary expectations?",
      "why are you applying?",
      "why arn't you interested in moving with your current organization if you are working?",
      "why do you want to work with us?",
      "tell me about yourself?",
      "what aspect of tech are you into, web, mobile, data and blockchain?",
      "how far is your home from our office?",
      "would you require sponsorship for relocation when necessary?",
      "where do you see your self in the next 5 years working with us or in your personal life?",
      "where do you stay?",
      "how long do you intend to stay with us if you get hired?",
      "are you single, married?",
      "what's your nationality?",
    ],
    answers: [],
    index: 0,
  });

  const startInterview = async (input) => {
    isSpeaking === true && speak(interview.questions[interview.index]).then(speech => {
      setSpeech(speech);
    });
    setInterview(prev => ({
      ...prev,
      answers: [...prev.answers, input],
    }));
    console.log(interview.answers)
    setMsg(prev => ({
      ...prev,
      value: [...prev.value, {
        msg: interview.questions[interview.index],
        type: "recieved"
      }],
      lastRecieved: interview.questions[interview.index],
      inputValue: "",
      notify: "Interviewing ...",
    }));
    if (interview.index !== interview.questions.length) {
      setInterview(prev => ({
        ...prev,
        index: prev.index + 1,
      }));

      // console.log(interview.answers)
    } else {
      var end = `Okay, it was a bery brief & awesome interview with you ${interview.answers[1]}, i will forward your details and answers to our HR for review .<br> And would you like to take a task after this interview`;

      setMsg(prev => ({
        ...prev,
        value: [...prev.value, {
          msg: end,
          type: "recieved"
        }],
        inputValue: "",
        notify: "Interview Ended!",
        lastRecieved: end
      }));
      speak(end).then(speech => {
        setSpeech(speech);
      });
      setTimeout(() => {
        setInterview({
          ...interview,
          started: false,
          ready: false,
          index: 0,
        });
      }, 2000)

    }

  };

  const speak = async (msg) => {
    if ("speechSynthesis" in window) {

      var synthesis = window.speechSynthesis;
      var utterance = new SpeechSynthesisUtterance(msg);
      utterance.text = msg;
      synthesis.speak(utterance)
      // console.log(synthesis)
      await synthesis.speaking === false && handleListing();
      // handleListing();
      setTalking(true);
      return synthesis;
    } else {
      alert("Text-To-Speech unsupported by your browser, use Google Chrome!");
      setIsSpeaking(false);
    }
  }

  const getReply = async (text) => {
    request.post("recruiter/", {
      input: text
    }).then(res => {
      // console.log(msg.value)
      // handleReset();
      // resetTranscript();
      setMsg(prev => ({
        ...prev,
        value: [...prev.value, {
          msg: res.data.answer,
          type: "recieved"
        }],
        inputValue: "",
        notify: "Recieved",
        lastRecieved: res.data.answer
      }));
      isSpeaking === true && speak(botMsg?.current.innerText).then(speech => {
        // alert(speech.speaking)
        setSpeech(speech)
      });

      if (res.data.answer === "opening directions...") {
        openModal("directions")
      } else if (res.data.answer === "input your email into the form field, so we can get back to you when necessary for (web, mobile, data science, blockchain)") {
        openModal("form");
      } else if (res.data.tag === "map"){
        speak("getting map location").then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
        // window.location.href = `https://www.google.com/search?q=${msg.inputValue}`;
        window.open(
          `https://google.com/maps/search/${res.data.location}`,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else if (res.data.tag === "test") {
        openModal("form");
      } else if (res.data.answer === "starting interview ...") {
        openModal("choose")
      } else if(res.data.tag === "code") {
        var data, link;

        data = res.data;
        link = data.moreResult;

        data = `
          <b>${data.text}</b>
          <br>
          <a target='_blank' href='${res.data.moreResult}'>View more answers</a>
          <div class='frame-link'>
            <img class='img-frame' src='data:image/jpeg;base64,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'></img>
            <a target='_blank' href='${data.to}'>View Code Snippest</a>
          </div>
          
        `

        setMsg(prev => ({
          ...prev,
          value: [...prev.value, {
            msg: data,
            type: "recieved"
          }],
          inputValue: "",
          notify: "Recieved",
          lastRecieved: data
        }));

        // speak("this is my search result from stackoverflow, this has more answers in it than the others").then(speech => {
        //   // alert(speech.speaking)
        // setSpeech(speech)
        // });

        isSpeaking === true && speak(botMsg?.current.innerText).then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
      } else if (res.data.website == "stackoverflow") {

        var data, link;
        link = res.data.link;

        // console.log(res.data)

        res.data.question !== undefined ? data = `
          <b>${res.data.title}</b>
          <p><i class='fa fa-eye'></i>${res.data.views} views</p>
          <p><i class='fa fa-comments'></i>${res.data.answers} answers on this question</p>
          <a target='_blank' href='${res.data.viewMore}'>View (${res.data.question.length}) more answers on other related questions</a>
          <div class='frame-link'>
            <img class='img-frame' src='data:image/png;base64,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'></img>
            <a target='_blank' href='${link}'>Visit</a>
          </div>
          
        ` : data = res.data.error
        setMsg(prev => ({
          ...prev,
          value: [...prev.value, {
            msg: data,
            type: "recieved"
          }],
          inputValue: "",
          notify: "Recieved",
          lastRecieved: data
        }));

        // speak("this is my search result from stackoverflow, this has more answers in it than the others").then(speech => {
        //   // alert(speech.speaking)
        // setSpeech(speech)
        // });

        isSpeaking === true && speak(botMsg?.current.innerText).then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
      } else if(res.data.tag === "youtube") {
        speak("this is my search result").then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
        // window.location.href = `https://www.google.com/search?q=${msg.inputValue}`;
        window.open(
          `https://www.youtube.com/search?q=${res.data.value}`,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else if (res.data.website === "github") {
        var data, link, apidata;
        apidata = res.data.output
        // console.log(apidata)

        if (res.data.type === "issues") {
          data = `
            <b>${apidata.title}</b>
            <p><i class='fa fa-comments'></i>${apidata.comments} answers</p>
            <a target='_blank' href='https://github.com/search?q=${res.data.input}&type=issues'>View more (${res.data.total}) related issues </a>
            <div class='frame-link'>
              <img class='img-frame' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS4AAACnCAMAAACYVkHVAAAAmVBMVEX///8bHyMWExIAAADDwsIOCgk7OTnS0tHu7u4VERAYHCBLSUnr6+t1dHQQDAv19fWvrq6DgoEkISAIAAC5ubmIh4dQT04AAAsxLy8NExje3t4dGRkUGR0AAAUoJiVaWVgAChGen6DJyco8P0JnaWszNjmtrKza2tokJyuWmJlMTlGOj5B8fX9DRUheYGJTVVc5Oz9vbm1DQUEKO4C5AAAKc0lEQVR4nO1d2WKqMBAVg0UQRStWoVABrUtdetv//7gLZDEEUKBWaMh5Y4vJ6WQyW9JOR0BAQEBAQEBAQEBA4I7QZX9yPr3vQryvPtd7U6m7R42F7a8lAOae5ThaBMexPBeAj0PQr7trjcP2sAJzS5PScDwgrc26+9ckGON/wHMyqELQLHc+s+vuZUPQ30vgCleIMQ+shR4LsZfmWXMwDcs9t17CTK0gWTFh4Nhqra+fQXGyInhOi5X+2LJKkRVCA2uj7m7XA2NYUrSQgO1aqfL107wCWVJkiI3r7vvjsS0/ETE0cKi7949GYN00ta4AHOvu/2MRXDPii/A1rHsEj0RQScm3la+t9jPZivlqjf7q737OVsjXpu5xPAgf9JpYblbSb4N22F8zyt7SPA9cjd1Qr1oumFvUt86uDfa9DCgKdv2Oofgn96YNFnria1MPXXLqa+9c91h+H4ZDTShrDW8qQ3CVMG2+81EsgqJLAvyb90OPGq9L4gv2Og4Rao7lzQGC61mQW8/zybz7pHjVNN7jOQEtHRKg4n3BCXjAWp0nvhwo262iBOb++Pnuut78SCkpn6bb+3r8CB6KU0Ktg8Sz/UTW2fcNezyU6Rtykm++V0czMVhtV74FO9GCc7p/HxuEpIHqrMq3oCfokoB8+5M/i6Rw3YMu6/P+vWwMPpIGqSaVb2KbpItn7aUwQ2VUfSEwAipZ/C6OQ9YWBdvSbew9tg1eXSGDFS5p7pdu5J11MCu08TfAzqNQMvalG/nHSqjz8QtdbQLW7Ei9dflGUsEyzUrZtlzAYGNbznsVtSOzMury6WgrLjvOagl8VkgtPsP27JpW1YFhDNWKQtp4sFIBqlaHnNmGeFRexntSdWleVaFgtVdl3puMPqO6qpvjfWbN8MqbI80H6wHNqye+PpO2BJe63mSk6we+8TGpvKoENhoPn6lPmldX0H5yjdWsO3azKTgwY9Sq0zVmBfWO3WwKmBmkSdWzOKl5zaHhtf5FujjMnzHGpebccTJyaKeytvhPVP2cf7pSPlD1LRjMqsHlZDyydFVPeaWY51DVsyLhVQ8aMwklLg0JVuFUd136O8ZZ59FMZZezKhl/CNb75NIJSicZq+p6Ns5oVQj5Nx59lq7KGa8Vo7q4DOCw4UHJea/WUFpMeQwPpvNmbjVTItUOj1ZqRrq+Wm5jy25U4zS1kZpE1XYSfLLCxWlRSSotK2lu+cXRT5Hucrp9g3Wyo3lU1ttL5bBDI5XT/f/pkhLJOpXjS/ZSm2K4LSlJFyyFfO3KyIafsbGP24IluhyODNspXrRknzP45jJ6A0H2IFjAA2Rbi7sqZGb2D5m7t7n0gBDQJgQr2kqtDF0kYo6r7W9MSSNYu2m1FQtX8JCe1wIUlUASIUvY+dM8sJqZdra5qSubLylvixXXheIdDUrIHB41YksXZ9nxgLd7T+kx4/SuudkHe0Hh4nkbArElLDhMpkjeyghcXd/lzvkmFxJ80aDO8W9viDqyrmbiC441VwSyODq72ACg92Vbmbtf7St08bwsQpDtn7Dsub+78JVTk8smMi74SWr3j8AgughOJH2HzzvTcqLRbAqJmoqcOtc0iJPs/IM3Zg7wLM8DTk5qiK2IuExFro0IjCOO72EjQDdnx+M+vVMWIchyfSK6Je6nYowVUlfZqj2FdFgxyTbv6GPrtNiAc+gC3EYiWGyR+1csspdNF5j8ejcbA2yqO1aBYEQmXS6P1c65kFE0QgOfJolX5SR0suhyubdPk5DxucUWkD6+JofZ8XzKsQsy6AItYyvUXw4256ODXDzPsqycoHuKLg3MHtvXJkBfsTvQCtKlua1ZE2kY62RsJo8uxky1LM6jELnYJKLvhejSwJnbVMZN2B+UgBWhy/rBxiseML6cVn+bLgus2+Em5sM4OIiwvEAypssBn23VWjT6B+A6t+jSLHASZCFs/gHPyrOmjPCZ64j/tEFDma1zj9lVvtabtussAQEBAQGBNsIwuKx5/wUom+Hye7FYPL2sj774F4tXYewXAIBpbzQa9XrRcde9l6JZwf5mHINOemzhvc0tN8gYI1Tsdk3wQ366CahTkhfU/YN/xUiX8YHilEBO0K23G7+r4G//Uqm9sQRqNwVciuXH48kPW8kAvU/RNYP3ek83flnB3/4huownkCarq3ahRMlgFF3lb6prG12fWWx1e9/w6ROcpb3nvM9bRtc+wZYaAo4AJultPE/RJkR9AnEJ3rSLLp3SW5GSGsULIxih8pELXXBERDkT+6xddB3Bhaz1RrF1XbeDzfANSZPxPIJSh85+IANsJ139KRYusEz0GV8c4Ihw6LTldPlYuHILis5gOpoCXAnXcrpeprDD05fcV8Yvby/E7Go5Xai/atGT6NtNV4D6O80vOzUg0NUWD1DHd+9ElxEcvpbLr1mjs20b3N9co/3r+S3Ca5z3sTdL5FuO4F3jNl3+8yLC2xI9C+D1InpG6JInr5GLP438zAb728iMUPNPwhiAUYTov3dG3iNSdSFf8V2doouKlNF0TWADvVf0zETXkWWikIUGjEjDoLkHJyzh8EevuW8MoDhFdH2lvCWart7ygqcRTRf8CexFmZjeDkVXstXGVv1+I49wgK77OoV4dlF0Da/S1e1NCZCoVKSr29h9aQs4MCL/IIGIr+J0pVGVritWTb14GyXF/3V06TRUaInJiP3vLvTF1bvRpcK/D/kzNNOwwB4hqQ65SlektDFfqhqr6/596BqB83irKzPizzfzhK9ydBmhPiProB2rt85d6FJVVK6DXbLpku1pI0DoKjQZI+Rb9dC0gFBL0vWKbTa09KjTx4y/LLCqx9sEfkCXungieFYr0rWnHjYQOLSMIs0dWuOWpIu2dCcJM7UEXdgpa+jJL4gMtYuuAzPEjDb1i9OV4wSVomvbbLqwoZ5YueX66LKbTRdeihIutqArD3isiZVb0JUHIys8WCNd6eabBcRGwk2rka6AethE4Pgg4aPzW3Rd4l1X6EJ216jbaSb6vUviDM/HQnQRKyuLrgy7iwhMJl2YfJRpaagT1CGCEPUffB82440/w8ZYFl3EMCIhvFt0HfBzGFTuDzPo6qFiMkJl7haHumF0L34PzPfjUq9MunScxgXLjWlGJWC36BqT6T4x5c2QRGnoiIQKng5j2TySiERzT+jIjShk0oUjZOGEiZjd3qZLocQ3BAmYJcODPTreNXpt6MIYYZ/DVzZdM/rtInQl3Hb6205+8LmxwfoIh6ziwTy67NJ0HXI46Vx0V/LJqOEntJsgg7AeiMMULF2hMFIVTkXo6iySfE1hAxe61F7i569UKjYExqQHpnSXQ1UygJ3+BnFuh0r+HaiYekxXL8KUpusI74FFfKV/X7KIKgDLYBE9hnTFX+pHKs94rQ62MehvznQO6OmAd2/6g5cIAyq3rKzxa6/hrLHhCy9LSj2P0UdHdL1/Ji0fw4aP34PBIDKt9Oi9QfiXsCdd/MK5YLVG7diaGz/COLi5MAVj39/kHniWAduMW75CBXxDbqZvLSAgICAgICAgICAgICAgICAgICDAN/4Dod3FmWpVkGEAAAAASUVORK5CYII='></img>
              <a target='_blank' href='${apidata.url?.replace("api.", "").replace("repos/", "")}'>Visit</a>
            </div>`

        } else if (res.data.type === "users") {
          data = `
            <p><i class='fa fa-user'></i> <b>${apidata.login}</b> GitHub user</p>
            <a target='_blank' href='https://github.com/search?q=${res.data?.input}&type=users'>View more (${res.data.total}) related users </a>
            <div class='frame-link'>
              <img class='img-frame' src='${apidata.avatar_url}'></img>
              <a target='_blank' href='${apidata.html_url}'>Open</a>
            </div> 
          `
        } else if (res.data.type === "repo") {
          data = `
            <b>${apidata?.full_name}</b>
            <br>
            <a target='_blank' href='https://github.com/${apidata?.full_name}/archive/refs/heads/main.zip'><i class='fa fa-download'></i> Download</a>
            <br>
            <a target='_blank' href='https://github.com/search?q=${res.data?.input}&type=repositories'>View more (${res.data.total}) related repos </a>
            <div class='frame-link'>
            <img class='img-frame' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS4AAACnCAMAAACYVkHVAAAAmVBMVEX///8bHyMWExIAAADDwsIOCgk7OTnS0tHu7u4VERAYHCBLSUnr6+t1dHQQDAv19fWvrq6DgoEkISAIAAC5ubmIh4dQT04AAAsxLy8NExje3t4dGRkUGR0AAAUoJiVaWVgAChGen6DJyco8P0JnaWszNjmtrKza2tokJyuWmJlMTlGOj5B8fX9DRUheYGJTVVc5Oz9vbm1DQUEKO4C5AAAKc0lEQVR4nO1d2WKqMBAVg0UQRStWoVABrUtdetv//7gLZDEEUKBWaMh5Y4vJ6WQyW9JOR0BAQEBAQEBAQEBA4I7QZX9yPr3vQryvPtd7U6m7R42F7a8lAOae5ThaBMexPBeAj0PQr7trjcP2sAJzS5PScDwgrc26+9ckGON/wHMyqELQLHc+s+vuZUPQ30vgCleIMQ+shR4LsZfmWXMwDcs9t17CTK0gWTFh4Nhqra+fQXGyInhOi5X+2LJKkRVCA2uj7m7XA2NYUrSQgO1aqfL107wCWVJkiI3r7vvjsS0/ETE0cKi7949GYN00ta4AHOvu/2MRXDPii/A1rHsEj0RQScm3la+t9jPZivlqjf7q737OVsjXpu5xPAgf9JpYblbSb4N22F8zyt7SPA9cjd1Qr1oumFvUt86uDfa9DCgKdv2Oofgn96YNFnria1MPXXLqa+9c91h+H4ZDTShrDW8qQ3CVMG2+81EsgqJLAvyb90OPGq9L4gv2Og4Rao7lzQGC61mQW8/zybz7pHjVNN7jOQEtHRKg4n3BCXjAWp0nvhwo262iBOb++Pnuut78SCkpn6bb+3r8CB6KU0Ktg8Sz/UTW2fcNezyU6Rtykm++V0czMVhtV74FO9GCc7p/HxuEpIHqrMq3oCfokoB8+5M/i6Rw3YMu6/P+vWwMPpIGqSaVb2KbpItn7aUwQ2VUfSEwAipZ/C6OQ9YWBdvSbew9tg1eXSGDFS5p7pdu5J11MCu08TfAzqNQMvalG/nHSqjz8QtdbQLW7Ei9dflGUsEyzUrZtlzAYGNbznsVtSOzMury6WgrLjvOagl8VkgtPsP27JpW1YFhDNWKQtp4sFIBqlaHnNmGeFRexntSdWleVaFgtVdl3puMPqO6qpvjfWbN8MqbI80H6wHNqye+PpO2BJe63mSk6we+8TGpvKoENhoPn6lPmldX0H5yjdWsO3azKTgwY9Sq0zVmBfWO3WwKmBmkSdWzOKl5zaHhtf5FujjMnzHGpebccTJyaKeytvhPVP2cf7pSPlD1LRjMqsHlZDyydFVPeaWY51DVsyLhVQ8aMwklLg0JVuFUd136O8ZZ59FMZZezKhl/CNb75NIJSicZq+p6Ns5oVQj5Nx59lq7KGa8Vo7q4DOCw4UHJea/WUFpMeQwPpvNmbjVTItUOj1ZqRrq+Wm5jy25U4zS1kZpE1XYSfLLCxWlRSSotK2lu+cXRT5Hucrp9g3Wyo3lU1ttL5bBDI5XT/f/pkhLJOpXjS/ZSm2K4LSlJFyyFfO3KyIafsbGP24IluhyODNspXrRknzP45jJ6A0H2IFjAA2Rbi7sqZGb2D5m7t7n0gBDQJgQr2kqtDF0kYo6r7W9MSSNYu2m1FQtX8JCe1wIUlUASIUvY+dM8sJqZdra5qSubLylvixXXheIdDUrIHB41YksXZ9nxgLd7T+kx4/SuudkHe0Hh4nkbArElLDhMpkjeyghcXd/lzvkmFxJ80aDO8W9viDqyrmbiC441VwSyODq72ACg92Vbmbtf7St08bwsQpDtn7Dsub+78JVTk8smMi74SWr3j8AgughOJH2HzzvTcqLRbAqJmoqcOtc0iJPs/IM3Zg7wLM8DTk5qiK2IuExFro0IjCOO72EjQDdnx+M+vVMWIchyfSK6Je6nYowVUlfZqj2FdFgxyTbv6GPrtNiAc+gC3EYiWGyR+1csspdNF5j8ejcbA2yqO1aBYEQmXS6P1c65kFE0QgOfJolX5SR0suhyubdPk5DxucUWkD6+JofZ8XzKsQsy6AItYyvUXw4256ODXDzPsqycoHuKLg3MHtvXJkBfsTvQCtKlua1ZE2kY62RsJo8uxky1LM6jELnYJKLvhejSwJnbVMZN2B+UgBWhy/rBxiseML6cVn+bLgus2+Em5sM4OIiwvEAypssBn23VWjT6B+A6t+jSLHASZCFs/gHPyrOmjPCZ64j/tEFDma1zj9lVvtabtussAQEBAQGBNsIwuKx5/wUom+Hye7FYPL2sj774F4tXYewXAIBpbzQa9XrRcde9l6JZwf5mHINOemzhvc0tN8gYI1Tsdk3wQ366CahTkhfU/YN/xUiX8YHilEBO0K23G7+r4G//Uqm9sQRqNwVciuXH48kPW8kAvU/RNYP3ek83flnB3/4huownkCarq3ahRMlgFF3lb6prG12fWWx1e9/w6ROcpb3nvM9bRtc+wZYaAo4AJultPE/RJkR9AnEJ3rSLLp3SW5GSGsULIxih8pELXXBERDkT+6xddB3Bhaz1RrF1XbeDzfANSZPxPIJSh85+IANsJ139KRYusEz0GV8c4Ihw6LTldPlYuHILis5gOpoCXAnXcrpeprDD05fcV8Yvby/E7Go5Xai/atGT6NtNV4D6O80vOzUg0NUWD1DHd+9ElxEcvpbLr1mjs20b3N9co/3r+S3Ca5z3sTdL5FuO4F3jNl3+8yLC2xI9C+D1InpG6JInr5GLP438zAb728iMUPNPwhiAUYTov3dG3iNSdSFf8V2doouKlNF0TWADvVf0zETXkWWikIUGjEjDoLkHJyzh8EevuW8MoDhFdH2lvCWart7ygqcRTRf8CexFmZjeDkVXstXGVv1+I49wgK77OoV4dlF0Da/S1e1NCZCoVKSr29h9aQs4MCL/IIGIr+J0pVGVritWTb14GyXF/3V06TRUaInJiP3vLvTF1bvRpcK/D/kzNNOwwB4hqQ65SlektDFfqhqr6/596BqB83irKzPizzfzhK9ydBmhPiProB2rt85d6FJVVK6DXbLpku1pI0DoKjQZI+Rb9dC0gFBL0vWKbTa09KjTx4y/LLCqx9sEfkCXungieFYr0rWnHjYQOLSMIs0dWuOWpIu2dCcJM7UEXdgpa+jJL4gMtYuuAzPEjDb1i9OV4wSVomvbbLqwoZ5YueX66LKbTRdeihIutqArD3isiZVb0JUHIys8WCNd6eabBcRGwk2rka6AethE4Pgg4aPzW3Rd4l1X6EJ216jbaSb6vUviDM/HQnQRKyuLrgy7iwhMJl2YfJRpaagT1CGCEPUffB82440/w8ZYFl3EMCIhvFt0HfBzGFTuDzPo6qFiMkJl7haHumF0L34PzPfjUq9MunScxgXLjWlGJWC36BqT6T4x5c2QRGnoiIQKng5j2TySiERzT+jIjShk0oUjZOGEiZjd3qZLocQ3BAmYJcODPTreNXpt6MIYYZ/DVzZdM/rtInQl3Hb6205+8LmxwfoIh6ziwTy67NJ0HXI46Vx0V/LJqOEntJsgg7AeiMMULF2hMFIVTkXo6iySfE1hAxe61F7i569UKjYExqQHpnSXQ1UygJ3+BnFuh0r+HaiYekxXL8KUpusI74FFfKV/X7KIKgDLYBE9hnTFX+pHKs94rQ62MehvznQO6OmAd2/6g5cIAyq3rKzxa6/hrLHhCy9LSj2P0UdHdL1/Ji0fw4aP34PBIDKt9Oi9QfiXsCdd/MK5YLVG7diaGz/COLi5MAVj39/kHniWAduMW75CBXxDbqZvLSAgICAgICAgICAgICAgICAgICDAN/4Dod3FmWpVkGEAAAAASUVORK5CYII='></img>
              <a target='_blank' href='https://github.com/${apidata?.full_name}'>View More</a>
            </div>

          `
        } else if (res.data.type === "code"){
          data = `
            <b>${apidata?.text}</b>
            <br>
            <div class='frame-link'>
            <img class='img-frame' src='data:image/png;base64,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'></img>
              <a target='_blank' href='ttps://github.com/search?q=${text}&type=code'>View More</a>
            </div>

          `

        }


        apidata == undefined && (data = res.data.error); 
        setMsg(prev => ({
          ...prev,
          value: [...prev.value, {
            msg: data,
            type: "recieved"
          }],
          inputValue: "",
          notify: "Recieved",
          lastRecieved: data
        }));
      } else if(res.data.answer === "searching..."){
        speak("this is my search result").then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
        // window.location.href = `https://www.google.com/search?q=${msg.inputValue}`;
        window.open(
          `https://google.com/search?q=${msg.inputValue}`,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else if (res.data.redirect === "yes" || res.data.tag === "google") {
        speak("this is my search result").then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
        // window.location.href = `https://www.google.com/search?q=${msg.inputValue}`;
        window.open(
          `${res.data.to}`,
          '_blank' // <- This is what makes it open in a new window.
        );
      } else if (res.data.tag === "search") {
        
        var data, link;
        link = res.data.link;

        data = `
          <h3>${res.data.title}</h3>
          <p>${res.data.description}</p>
          <a href=${res.data.moreResult}>More Results</a>
          <div class='frame-link'>
            <iframe src=${link}></iframe>
            <a target='_blank' href=${link}>Visit</a>
          </div>  
        `;

        setMsg(prev => ({
          ...prev,
          value: [...prev.value, {
            msg: data,
            type: "recieved"
          }],
          inputValue: "",
          notify: "Recieved",
          lastRecieved: data
        }));

        isSpeaking === true && speak(botMsg?.current.innerText).then(speech => {
          // alert(speech.speaking)
          setSpeech(speech)
        });
      }

    });
  }

  // var link = "/url?q=https://www.investopedia.com/insights/what-is-money/&sa=U&ved=2ahUKEwiq-_Lsx4L1AhVkUGwGHZCgB6MQFnoECAgQAg&usg=AOvVaw0rX4HKH00vNn2rQHLu-i6a".split("/url?q=")[1];
  // console.log(link.split("/"))

  useEffect(() => {
    if (finalTranscript !== '') {
      speech?.speaking === false && setTalking(false);

      console.log('Got final result:', finalTranscript);
      talking === false && setMsg({
        ...msg,
        inputValue: `${finalTranscript}`,
        notify: "Replying ..."
      });

      resetTranscript();
    }

  }, [interimTranscript, finalTranscript]);

  useEffect(() => {
    const domNode = messageArea.current;
    if (domNode) {
      // console.log(domNode)

      domNode.scrollTop = domNode.scollHeight;
      domNode.addEventListener("DOMNodeInserted", event => {
        // event.target.scroll({
        //   top: event.target.scrollHeight, 
        //   behavior: "smooth"
        // });

        event.target.scrollIntoView({ behavior: "smooth", block: "start" });

      })
    }
    // messageArea.current?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    // openModal("choose")

  }, []);

  const [modal, setModal] = useState({
    modal: false,
    type: "",
  })

  const location = {
    address: 'Lagos, Nigeria',
    lat: 6.52484153777444,
    lng: 3.3718377624173757,
  }


  const openModal = (type) => {
    type === "form" && setModal({
      ...modal,
      modal: true,
      type: "form",
    });
    type === "directions" && setModal({
      ...modal,
      modal: true,
      type: "directions"
    });
    type === "choose" && setModal({
      ...modal,
      modal: true,
      type: "choose"
    });
    type === "search" && setModal({
      ...modal,
      modal: true,
      type: "search"
    });

    (isSpeaking === true && type === "choose") && speak(`Our location is at: ${location.address}`);
  }

  const [form, setForm] = useState({
    customerEmail: "",
  })

  return (
    <div className="App">

      {(modal.type === "form" && modal.modal === true) &&
        <div className="modal">
          <div className="modal-content" id="form">
            <button className="fa fa-times close-modal" onClick={() => {
              setModal({
                modal: false,
                type: ""
              })
            }}></button>
            <input placeholder="Your email" onChange={event => {
              setForm({
                ...form,
                customerEmail: event.target.value
              })
            }} />
            <button className="fa fa-paper-plane send" onClick={() => {
              if (form.customerEmail === "") {
                speak("Please, kindly insert an email into the field")
              } else {
                setModal({
                  modal: false,
                  type: ""
                });
                setMsg(prev => ({
                  ...prev,
                  value: [...prev.value, {
                    msg: "Your email has been recieved, we will get back to you shortly",
                    type: "recieved"
                  }],
                  inputValue: "",
                  notify: "Email Sent",
                  lastRecieved: "Your email has been recieved, we will get back to you shortly"
                }));
              }
            }}></button>
          </div>
        </div>}
      {(modal.type === "directions" && modal.modal === true) && <div className="modal">
        <div className="modal-content" id="directions">
          <button className="fa fa-times close-modal" onClick={() => {
            setModal({
              modal: false,
              type: ""
            })
          }}></button>
          <MapSection location={location} zoomLevel={12} />
          <div className="bar">Location: <b>{location.address}</b></div>
          {/* <iframe src="https://satellites.pro/Lagos_map.Nigeria"></iframe> */}
          {/* <iframe src="https://www.google.com.ng/maps/dir/Ojodu+Berger/@6.6431854,3.3483946,15z/data=!4m16!1m7!3m6!1s0x103b9381601e96b5:0x8d79a42c1c6bb9d4!2sOjodu+Berger!3b1!8m2!3d6.6470456!4d3.374176!4m7!1m0!1m5!1m1!1s0x103b9381601e96b5:0x8d79a42c1c6bb9d4!2m2!1d3.3741647!2d6.6470273?hl=en"></iframe> */}
        </div>
      </div>
      }
      {(modal.type === "search" && modal.modal === true) && <div className="modal">
        <div className="modal-content" id="directions">
          <button className="fa fa-times close-modal" onClick={() => {
            setModal({
              modal: false,
              type: ""
            })
          }}></button>
          <iframe src={`https://www.google.com/search?q=${msg.inputValue}`}></iframe>
        </div>
      </div>
      }
      {
        (modal.type === "choose" && modal.modal === true) && <div className="modal">
          <div className="modal-content" id="choose">
            <button className="fa fa-times close-modal" onClick={() => {
              setModal({
                modal: false,
                type: ""
              })
            }}></button>
            <p>Are you ready for the interview?</p>
            <div className="row">
              <button className="send" onClick={() => {
                setInterview({
                  ...interview,
                  ready: true,
                  started: true,
                });
                setModal({
                  modal: false,
                  type: ""
                });

                startInterview();
              }}>Yes</button>
              <button className="send" onClick={() => {
                setInterview({
                  ...interview,
                  ready: false,
                  started: false,
                });
                setModal({
                  modal: false,
                  type: ""
                });

                setMsg(prev => ({
                  ...prev,
                  value: [...prev.value, {
                    msg: "Alright, next time you can still take the interview",
                    type: "recieved"
                  }],
                  inputValue: "",
                  notify: "Recieved",
                  lastRecieved: "Alright, next time you can still take the interview"
                }));

              }}>No</button>
            </div>

          </div>
        </div>
      }

      <header>
        <nav className="row space-between">
          <div className="navbrand">
            <a href="/" className="row space-between">
              <i className="fa fa-robot"></i>
              <h3>Chat Bot</h3>
            </a>
          </div>
          <div className="navlinks row">
            <a target="_blank" href="https://j-resume.netlify.app" className="fa fa-user"></a>
            <a target="_blank" href="https://twiiter.com/AkinleyeJoshua9" className="fab fa-twitter"></a>
            <a target="_blank" href="https://www.linkedin.com/in/joshua-akinleye-9895b61ab/" className="fab fa-linkedin"></a>
          </div>
        </nav>
      </header>
      <main className="col">
        <div className="message-area col" ref={messageArea}>
          {arrMsg}
        </div>
        <form method="dialog">
          <div className="row section-form">
            <div className="row input-bar">
              <input placeholder="Message" value={msg.inputValue} onChange={event => {
                setMsg({
                  ...msg,
                  inputValue: event.target.value
                })
              }} />
              {autoSent !== true && <button className="fa fa-paper-plane send" onClick={() => {
                setMsg({
                  ...msg,
                  value: [...msg.value, {
                    msg: msg.inputValue,
                    type: "sent"
                  }
                  ],
                  inputValue: "",
                  notify: "Typing ..."
                })
                if (msg.inputValue === "") {
                  setMsg({
                    ...msg,
                    notify: "No Message?!"
                  });
                } else {
                  setMsg(prev => ({
                    ...prev,
                    lastRecieved: ""
                  }))
                  interview.started === true ? startInterview(msg.inputValue) : getReply(msg.inputValue);
                }
              }}></button>}
            </div>
            <div className="row actions">
              {/* {autoSent === true ? <button className="fa fa-repeat listening" onClick={
                () => {
                  setAutoSend(false)
                }
              }></button> : <button className="fa fa-repeat" onClick={
                () => {
                  setAutoSend(true);
                  autoSent !== false && setInterval(() => {
                    setMsg({
                      ...msg,
                      value: [...msg.value, {
                        msg: msg.inputValue,
                        type: "sent"
                      }
                      ],
                      inputValue: "",
                      notify: "Typing ..."
                    })
                    if (msg.inputValue === "") {
                      setMsg({
                        ...msg,
                        notify: "No Message?!"
                      });
                    } else {
                      setMsg(prev => ({
                        ...prev,
                        lastRecieved: ""
                      }))
                      interview.started === true ? startInterview() : getReply(msg.inputValue);
                    }
                  }, );
                  // autoSend();

                }
              }></button>} */}

              {isListening === true ? <button onClick={stopHandle} className="fa fa-microphone listening" ref={microphoneRef}></button> :
                <button onClick={handleListing} className="fa fa-microphone" ref={microphoneRef}></button>
              }
              {isSpeaking === true ? <button className="fa fa-volume-up listening" onClick={() => {
                setIsSpeaking(false);
                // speak("");
              }}></button> : <button className="fa fa-volume-up" onClick={() => {
                setIsSpeaking(true);
                // speak(msg.lastRecieved);
              }}></button>
              }

            </div>
            <div className="notify row">
              {msg.notify === "" ? <i className="fa fa-smile"></i> : msg.notify}
            </div>
          </div>
        </form>
      </main>
    </div>
  );
}

export default App;
